interface MobileActionBarProps {
    primaryLabel: string;
    primaryIcon: string;
    primaryDisabled?: boolean;
    onPrimary: () => void;
    onParticipants: () => void;
    onMap: () => void;
    onShare: () => void;
    onAbout: () => void;
    activeTab: "about" | "participants" | "map";
}



export default function MobileActionBar({ primaryLabel, primaryIcon, primaryDisabled = false, onPrimary, onParticipants, onMap, onShare, onAbout, activeTab }: MobileActionBarProps) {
    return (
        <nav className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white border-t border-background-200 h-16">
            <div className="h-full grid grid-cols-5">
                {/* Action principale */}
                <button
                    type="button"
                    onClick={onPrimary}
                    disabled={primaryDisabled}
                    className="
                    flex flex-col items-center justify-center gap-[.12rem] px-1
                    m-[.3rem] ml-[0.5rem] rounded-[.17rem]
                    
                    bg-primary-500 text-white
                    transition-colors cursor-pointer
                    disabled:opacity-60 disabled:cursor-not-allowed
                    "
                >
                    <i className={`${primaryIcon} text-[1.25rem] leading-[1.25rem]`}></i>
                    <span className="text-[10px] font-semibold text-center leading-tight px-1">
                        {primaryLabel}
                    </span>
                </button>

                {/* À propos */}
                <button
                    type="button"
                    onClick={onAbout}
                    className={`flex flex-col items-center justify-center gap-1 px-1 transition-colors cursor-pointer ${activeTab === "about"
                        ? "bg-background-100 text-foreground-900"
                        : "text-foreground-600 hover:bg-background-50"
                        }`}
                >
                    <i className="ri-information-line text-xl"></i>
                    <span className="text-[10px] font-medium">À propos</span>
                </button>

                {/* Participants */}
                <button
                    type="button"
                    onClick={onParticipants}
                    className={`flex flex-col items-center justify-center gap-1 px-1 transition-colors cursor-pointer ${activeTab === "participants"
                        ? "bg-background-100 text-foreground-900"
                        : "text-foreground-600 hover:bg-background-50"
                        }`}
                >
                    <i className="ri-group-line text-xl"></i>
                    <span className="text-[10px] font-medium">Participants</span>
                </button>

                {/* Carte */}
                <button
                    type="button"
                    onClick={onMap}
                    className={`flex flex-col items-center justify-center gap-1 px-1 transition-colors cursor-pointer ${activeTab === "map"
                        ? "bg-background-100 text-foreground-900"
                        : "text-foreground-600 hover:bg-background-50"
                        }`}
                >
                    <i className="ri-map-pin-2-line text-xl"></i>
                    <span className="text-[10px] font-medium">Carte</span>
                </button>

                {/* Partager */}
                <button
                    type="button"
                    onClick={onShare}
                    className="flex flex-col items-center justify-center gap-1 px-1 text-foreground-600 hover:bg-background-50 transition-colors cursor-pointer"
                >
                    <i className="ri-share-line text-xl"></i>
                    <span className="text-[10px] font-medium">Partager</span>
                </button>
            </div>
        </nav>
    );
}